import React from "react";
import { ProgramContainer } from "src/entities/formTemplateDataType";
import { RuntimeComponent } from "./RuntimeComponent";
import { getCxpMessages, getUserProfileFromSession } from "./services/CxpProfileService";
import { checkProfileAccount, fetchSessionFromServer, signin } from "./security/PublicSecure";
import { getAppId, getPublicSecurePage } from "./utilities/ElementUtils";
import { SpinnerComponent } from "./commonComponent/SpinnerComponent";
import { getAdminConfig } from "./services/EnvConfigService";
import { getAppNameFromPath } from "./utilities/URLUtils";
import { parseJson } from "./utilities/JsonUtils";
import SectionUtils from "./utilities/SectionUtils";
import { AUTH_TOKENS, USER_PROFILE } from "./entities/Constants";
import { getEnvVar } from "./config/RuntimeConfig";
interface Props {

}

interface State {
    programContainer: ProgramContainer
    isEng: boolean
    isBusy: boolean
}


export class RuntimeWithLayout extends React.Component<Props, State> {
    constructor(props) {
        super(props);

       
        this.state = {
            isEng: true,
            programContainer: null,
            isBusy: true
        }
    }

    async getLayout() {

        const project = getEnvVar('PROJECT');
        const nodeEnv = (getEnvVar('ENVIRONMENT') ?? getEnvVar('NODE_ENV') ?? '').toLowerCase();
        const layoutUrl =
            nodeEnv === "local"
                ? `/${project}layout.json`
                : `/${project}/public/${project}layout.json`;

        const response = (await fetch(layoutUrl)).text();
        return response
    }

    async componentDidMount() {
        let programContainerRaw= await this.getLayout(); 
        let programContainer=parseJson(programContainerRaw, getAppNameFromPath());
        SectionUtils.hydrateParentReferences(programContainer);
        //populateElementFindRoot(programContainer);
        const userProfile = getUserProfileFromSession();
        programContainer.Profile = userProfile;

        const sessionUserProfile = sessionStorage.getItem(USER_PROFILE);
        const sessionAuthTokens = sessionStorage.getItem(AUTH_TOKENS);
        if (sessionUserProfile && !sessionAuthTokens) {
            signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile?.lang === 'en');
            return;
        }

        let busy = true;

        if (!userProfile?.token) {
            if (userProfile?.userId) {
                //get auth from CXP auth session
                programContainer = await fetchSessionFromServer(programContainer);
                console.log("fetch token form auth session: ", programContainer.Profile);
                if (!programContainer.Profile?.token) {
                    signin(programContainer.CategoryId, !programContainer.Profile?.lang || programContainer.Profile?.lang === 'en');
                }
                busy = false;
            }
            
            const url = new URL(window.location.href);
            const code = url.searchParams.get("code");
            const queryState = url.searchParams.get("state");

            if (code && queryState && !programContainer.Profile?.token) {
                busy = true;
                try {
                    console.log("get token and cxp profile");
                    const authToken = sessionStorage.getItem("authTokens");
                    let token = null;
                    if (authToken) {
                        token = JSON.parse(authToken);
                        // const validToken = verifyOktaToken(authToken);
                        // if (!validToken) {
                        //     signin(programContainer.CategoryId, programContainer.Profile?.lang === 'en');
                        // }
                    }

                    programContainer = await checkProfileAccount(programContainer, token);
                    console.log("after get token and cxp profile");
                    if (programContainer.Profile) {
                        console.log("after get token and cxp profile", programContainer.Profile);

                        if (programContainer.Profile && queryState.endsWith('FR')) {
                            programContainer.Profile.lang = 'fr';
                        }
                        if (programContainer.Profile && queryState.endsWith('EN')) {
                            programContainer.Profile.lang = 'en';
                        }
                        
                    }
                   
                    if (!programContainer?.Profile?.token) {
                        console.log("fetch token failure, re-signin");
                        //signin(programContainer.CategoryId, programContainer.Profile?.lang === 'en');
                    }
                } catch (error) {
                    console.log("error get token and cxp profile", error);
                }
                busy = false;
            }

            // token lost after refresh page
            if (programContainer.Profile?.userId && !programContainer.Profile?.token) {
                console.log("no token, redirect to signin");
                signin(programContainer.CategoryId, this.state.isEng);
            }

            if (programContainer.Profile?.userId && programContainer.Profile?.token) {
                const messages = await getCxpMessages(programContainer.Profile?.token, { pageNumber: 1, pageSize: 20, search: '' });
                programContainer.Profile.messages = messages?.messages;
                busy = false;
            }

            console.log("isBusy", this.state.isBusy);
            // no profile, redirect to first page
            if (!programContainer.Profile) {
                const section = getPublicSecurePage(programContainer.ListOfFormSections);
                console.log("no profile, redirect to first page");
                if (section) {
                    section.Visible = true;
                }
                busy = false;
            } 
            
        } else {
            busy = false
        }

        if (programContainer) {
            busy = true;
            const adminConfig = await getAdminConfig(programContainer.CategoryId);
            programContainer.adminConfig = adminConfig;
            busy = false;
        }
       
        this.setState({
            isEng: programContainer.Profile?.lang!=='fr',
            programContainer: programContainer,
            isBusy: busy
        });
    }

    render() {
        if (this.state.isBusy) {
            return <SpinnerComponent isBusy></SpinnerComponent>
        }

        if (this.state.programContainer == null)
            return null;
        console.log("render runtime with profile:", this.state.programContainer.Profile);
        return (<>
            <div>
                <RuntimeComponent programContainer={this.state.programContainer} ></RuntimeComponent>
            </div> </>
        )
    }
}
